<template>
  <div class="contragents-roadmaps">
    <i-table
      :show-header="false"
      :columns="columns"
      :data="roadmaps"
    />
  </div>
</template>

<script>
import { getFormattedCosts, round } from '@/utils'

const columns = [
  {
    title: 'Номер',
    key: 'number',
    width: 126
  },
  {
    title: 'Наименование этапа',
    key: 'name'
  },
  {
    title: 'Стоимость по договору, руб',
    key: 'costs',
    width: 161,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    }
  },
  {
    title: 'Информация о подписанных актах',
    key: 'sign_acts',
    width: 160
  },
  {
    title: 'Сумма поступившей оплаты (в т.ч. аванс), руб',
    key: 'payments_value',
    width: 192,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.payments_value, true))
    }
  },
  {
    title: 'Процент поступившей оплаты, %',
    key: 'payment_part',
    width: 128,
    render: (h, params) => {
      return h('span', round(params.row.payment_part * 100, 1))
    }
  }
]
export default {
  props: {
    roadmaps: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      columns
    }
  }
}
</script>

<style>

</style>
